// Tiny WebAudio-synthesized alert tones — no external audio files needed.
// Each preset is a function that plays a short sequence.

let audioCtx = null;
function getCtx() {
  if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  return audioCtx;
}

function beep(freq, durationMs, volume = 0.7, type = 'sine', startOffset = 0) {
  const ctx = getCtx();
  const t0 = ctx.currentTime + startOffset;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(volume, t0 + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + durationMs / 1000);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t0);
  osc.stop(t0 + durationMs / 1000 + 0.02);
}

export const SOUNDS = {
  chime:  { label: 'Chime (3 rising notes)',       play: (v) => { beep(660, 180, v); beep(880, 180, v, 'sine', 0.18); beep(1320, 260, v, 'sine', 0.36); } },
  alert:  { label: 'Alert (urgent double beep)',   play: (v) => { beep(880, 160, v, 'square'); beep(1200, 160, v, 'square', 0.18); } },
  siren:  { label: 'Siren (sweep)',                play: (v) => { beep(500, 400, v, 'sawtooth'); beep(900, 400, v, 'sawtooth', 0.40); beep(500, 400, v, 'sawtooth', 0.80); } },
  ping:   { label: 'Ping (single)',                play: (v) => { beep(1046, 320, v, 'triangle'); } },
};

// User-uploaded sounds (wav/mp3/…), stored as data URLs in localStorage and
// referenced from settings as `custom:<id>`.
const CUSTOM_KEY = 'power.customSounds';

export function listCustomSounds() {
  try {
    const parsed = JSON.parse(localStorage.getItem(CUSTOM_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch { return []; }
}

export function addCustomSound(label, dataUrl) {
  const sound = { id: Date.now().toString(36), label, dataUrl };
  const list = [...listCustomSounds(), sound];
  try {
    localStorage.setItem(CUSTOM_KEY, JSON.stringify(list));
  } catch {
    throw new Error('browser storage is full — use a smaller file or delete an existing custom sound');
  }
  return sound;
}

export function removeCustomSound(id) {
  const list = listCustomSounds().filter(s => s.id !== id);
  try { localStorage.setItem(CUSTOM_KEY, JSON.stringify(list)); } catch {}
}

export function playAlertSound(name = 'chime', volume = 0.7) {
  if (typeof name === 'string' && name.startsWith('custom:')) {
    const s = listCustomSounds().find(x => x.id === name.slice(7));
    if (s) {
      try {
        const a = new Audio(s.dataUrl);
        a.volume = Math.max(0, Math.min(1, volume));
        a.play().catch(() => {});
      } catch {}
      return;
    }
    // custom sound was deleted — fall through to a preset
  }
  const preset = SOUNDS[name] || SOUNDS.chime;
  try { preset.play(volume); } catch (e) { /* ignore — some browsers require user gesture */ }
}
